export const previewGameData = {
  "gameData": {
    "playerCount": 42,
    "createdLevels": 3,
    "status": "active",
    "gameName": "Gamably Preview Game",
    "createdItems": 27,
    "createdTeams": 2,
    "orgId": "1725944136600_org",
    "shortDesc": "The Gamably Preview: A Test Game for Exploring Our Features!",
    "ts_created": 1730324415923,
    "access": [
      "points",
      "leaderboards",
      "levels",
      "badges",
      "challenges",
      "secretCodes",
      "currency",
      "marketplace",
      "items",
      "prizepacks",
      "collections",
      "store"
    ],
    "joinCode": "gamably-preview",
    "creatorName": "Testy McTester",
    "color": "#674fa7",
    "enroll_upload": true,
    "path": "previewgame",
    "bg": {
      "url": "https://app.gamably.com/images/themes/2025/fantasy_bg.jpg",
      "type": "image"
    },
    "gameId": "previewgame",
    "creatorId": "aNapmyU75jGnponX7NyizAmjq4uZ",
    "border_header": "none",
    "createdChallenges": 6,
    "createdElementTotal": 86,
    "createdCollections": 6,
    "desc": `<p>This Gamably Preview Game is designed to showcase our features and functionality including:</p>
    <ul>
    <li>Points</li>
    <li>Leaderboards</li>
    <li>Levels</li>
    <li>Badges</li>
    <li>Challenges</li>
    <li>Secret Codes</li>
    <li>Items</li>
    <li>The Item Marketplace</li>    
    <li>Prize Packs</li>
    <li>Collections</li>
    <li>And More!</li>
    </ul>`,
    "icon": "/images/themes/2025/fantasy_icon.jpg",
    "border_icon": "none",
    "sortLeaders": "points",
    "header": "/images/themes/2025/fantasy_head.jpg",
    "createdLeaderboards": 7,
    "createdBadges": 4,
    "enroll_email": true,
    "createdPrizePacks": 3,
    "ts": 1770155494770,
    "type": "full",
    "createdSecretCodes": 30
  }
}

export const previewGameStats = {}

export const previewGameMessages = {}

export const previewRewardPresets = {}

export const previewUserContent = {
  "currentUser": {
    "displayName": "Testy McTester",
    "email": "preview@gamably.com",
    "metadata": {
      "createdAt": new Date().getTime(),
    },
    "photoURL": "https://gamably.com/images/themes/2025/gamably_icon.png",
    "provider": "preview",
    "uid": "preview-manager"
  },
  "membership": {
    "appId": "preview-manager",
    "email": "preview@gamably.com",
    "membership": 3,
    "ts": new Date().getTime(),
    "ts_expires": 0
  },
  "userProfile": {
    "admin": false,
    "appId": "preview-manager",
    "birthday": 21600000,
    "email": "preview@gamably.com",
    "fName": "Testy",
    "gamesCreated": [],
    "gradient": "linear-gradient(to left, #c1745f, #81b165)",
    "icon": "https://gamably.com/images/themes/2025/gamably_icon.png",
    "lName": "McTester",
    "legalApproved": new Date().getTime(),
    "name": "Testy McTester",
    "purpose": "Business",
    "status": "active",
    "stripeCustomerId": "preview-manager",
    "ts_created": new Date().getTime(),
    "ts_joined": new Date().getTime(),
    "ts": new Date().getTime(),
    "uid": "preview-manager"
  }
}